// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__1qd8H","marketplaceStroke":"IconEmailAttention_marketplaceStroke__mWzUk","attentionStroke":"IconEmailAttention_attentionStroke__3AVDK"};